<template>
    <div>
        <v-row align="center" class="my-n9">
            <v-col cols="3">
                <div class="d-flex align-center">
                    {{ field.Name }}
                </div>
            </v-col>
            <v-col cols="1">
                <div class="d-flex align-center">
                    <v-checkbox v-model="field.Selected" @change="addToPrompt()"></v-checkbox>
                </div>
            </v-col>
            <v-col>
                <div class="d-flex align-center">
                    <v-text-field :disabled="!field.Selected" @input="addAdditionalNotes()"
                        v-model="field.additionalNotes"></v-text-field>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import DeffieldService from '@/services/DefFieldService';
import Utils from '@/ecm/common/Utils';
import FieldType from '@/ecm/variables/FieldType';

export default {
    name: 'ContentTypeFieldsInfomaniakComponent',
    props: {
        field: {
            type: Object,
            default: null
        },
        refresh: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        refresh(newValue) {
            if (newValue) {
                this.field.Selected = !this.refresh;
            }
        }
    },
    methods: {
        addToPrompt() {
            const prompt = this.$t('InfomaniakPromptField').replace('{0}', this.field.Name).replace('{1}', this.field.Type).replace('{2}', this.field.Code);
            const fieldCode = this.field.Code;
            if (this.field.Selected) {
                this.validateListFieldsWithPerformanceQuery();
                this.$emit('addToPrompt', prompt, fieldCode);
            } else {
                this.field.additionalNotes = '';
                this.$emit('removeFromPrompt', prompt, fieldCode);
            }
        },
        addAdditionalNotes() {
            var prompt = this.$t('InfomaniakPromptField').replace('{0}', this.field.Name).replace('{1}', this.field.Type).replace('{2}', this.field.Code);
            this.$emit('addAdditionalNotes', prompt, this.field.additionalNotes);
        },
        validateListFieldsWithPerformanceQuery() {
            if (this.field.FieldType !== FieldType.DynamicTableList &&
                this.field.FieldType !== FieldType.DynamicList) return;
            this.loading = true;
            DeffieldService.checkIfDefFieldHasPerformanceQuery(this.field.Id)
                .then((data) => {
                    this.loading = false;
                    if (!data.fieldName) return;
                    Utils.toast.warning(this.$t('Site.AI.FieldHasNotPerformanceQuery').replaceAll('{0}', data.fieldName));
                })
                .catch(() => {
                    this.loading = false;
                });
        }

    }
};
</script>
